import { render, staticRenderFns } from "./inv-company.vue?vue&type=template&id=c0ca8586&scoped=true&"
import script from "./inv-company.vue?vue&type=script&lang=js&"
export * from "./inv-company.vue?vue&type=script&lang=js&"
import style0 from "./inv-company.vue?vue&type=style&index=0&id=c0ca8586&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0ca8586",
  null
  
)

export default component.exports